import React from "react";
import PropTypes from "prop-types";

import EventTimesheetApplicantPanel from "./EventTimesheetApplicantPanel";
import EventTimesheetListPanel from "./EventTimesheetListPanel";

const EventTimesheet = ({
  selectedApplicant,
  listProps,
  applicantProps,
}) => {
  if (selectedApplicant) {
    return <EventTimesheetApplicantPanel {...applicantProps} />;
  }

  return <EventTimesheetListPanel {...listProps} />;
};

EventTimesheet.propTypes = {
  selectedApplicant: PropTypes.object,
  listProps: PropTypes.object.isRequired,
  applicantProps: PropTypes.object,
};

EventTimesheet.defaultProps = {
  selectedApplicant: null,
  applicantProps: {},
};

export default EventTimesheet;
